module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-left-bottom-stone-path.60fc377c.png";